<script>
import DropDown from '../reUse/DropDown.vue';
import Zapisi from "./Jadralna_beri.vue";
import Notification from '../reUse/Notification.vue';
import {i18n} from '@/i18n'
import sl from '@/Prevodi/Jadralna-sl.json';
import en from '@/Prevodi/Jadralna-en.json';
import it from '@/Prevodi/Jadralna-it.json';
import {config} from "@/config";

export default {
  components: {
    DropDown,
    Zapisi,
    Notification
  },
  emits: ['odjava'],
  data() {
    return {
      prevodi: false,
      datum: new Date().toISOString().split('T')[0],
      datumO: new Date().toISOString().split('T')[0],
      datumD: new Date().toISOString().split('T')[0],
      pilotName: '',
      instructorName: '',
      regLetala: '',
      IzbranNamen: '',
      IzbranaNaloga: '',
      krajVzleta: 'LJAJ',
      krajPristanka: 'LJAJ',
      poletanje: '',
      casOdklopa: '',
      casVleke: '',
      pristanek: '',
      // kilometri: '',
      regVleka: '',
      opomba: '',
      //motorni let
      pilotNameM: '',
      pristanekM: '',
      IzbranNamenM: 'Vleka',
      IzbranaNalogaM: 'Vleka',
      dPilot: false,
      dPilotM: false,
      dLetalo: false,
      dInstruktor: false,
      dFiltri: false,
      dNamen: false,
      dNamenM: false,
      dNaloga: false,
      dPristanek: false,
      dVzlet: false,
      Letala: [],
      LetalaMotorna: [],
      dLetaloVleka: false,
      Piloti: [],
      PilotiV: [],
      Instruktor: [],
      Letalisca: [],
      namen: [
        {id: 0, namen: 'Trenažni let'},
        {id: 1, namen: 'Kontrolni let'},
        {id: 2, namen: 'Osnovno šolanje'},
        {id: 3, namen: 'Šolanje za poob.'},
        {id: 4, namen: 'Tekmovalni let'},
        {id: 5, namen: 'Izpitni let'},
        {id: 6, namen: 'Preizkusni let'},
        {id: 7, namen: 'Uvodni let'},
        {id: 8, namen: 'Protipožarni let'},
        {id: 9, namen: 'AK'},
        {id: 10, namen: 'Jadranje v rajonu'},
      ],
      naloga: [
        {id: 0, naloga: 'Šolski krog'},
        {id: 1, naloga: 'Prelet'},
        {id: 2, naloga: 'Let v rajonu'},
        {id: 3, naloga: 'Ruta'},
      ],
      prikaz: 'vnos',
      PodatkiObracun: [],
      PodatkiNezakljuceni: [],
      dodajanjeLetalisca: false,
      letalisceDodano: false,
      imeDodanegaLetalisca: null,
      novIcao: '',
      text: '',
      types: '',
      ShowNoti: false,
      nezakljucen: false,
      user: config.FullUser,
      vnasam: false
    }
  },
  created() {
    this.loadTranslationsDirekt('sl', sl);
    this.loadTranslationsDirekt('en', en);
    this.loadTranslationsDirekt('it', it);
    this.prevodi = true;
  },
  mounted() {
    this.GetLetala();
    this.GetPiloti();
    this.GetLetalisca();
    this.GetPodatkiObracuna();
    this.WriteLocal();
  },
  computed: {
    FilterVlecnihPilotov() {
      return this.PilotiV.piloti.filter(pilot => pilot.vlecni_rating == 1);
    },
    imeUpper: {
      get() {
        return this.novIcao;
      },
      set(value) {
        this.novIcao = value.toUpperCase();
      }
    }
  },
  methods: {
    WriteLocal() {
      const now = new Date().toISOString().split('T')[0];
      if (localStorage.getItem("Datum") === now) {
        if (localStorage.getItem("PilotName") !== null)
          this.pilotName = localStorage.getItem("PilotName");
        if (localStorage.getItem("InstructorName") !== null)
          this.instructorName = localStorage.getItem("InstructorName");
        if (localStorage.getItem("RegLetala") !== null)
          this.regLetala = localStorage.getItem("RegLetala");
        if (localStorage.getItem("Namen") !== null)
          this.IzbranNamen = localStorage.getItem("Namen");
        if (localStorage.getItem("Naloga") !== null)
          this.IzbranaNaloga = localStorage.getItem("Naloga");
        if (localStorage.getItem("KrajVzleta") === null || localStorage.getItem("KrajVzleta") === '') {
          this.krajVzleta = 'LJAJ';
        } else {
          this.krajVzleta = localStorage.getItem("KrajVzleta");
        }
        if (localStorage.getItem("KrajPristanka") === null || localStorage.getItem("KrajPristanka") === '') {
          this.krajPristanka = 'LJAJ';
        } else {
          this.krajPristanka = localStorage.getItem("KrajPristanka");
        }
        if (localStorage.getItem("Poletanje") !== null)
          this.poletanje = localStorage.getItem("Poletanje");
        if (localStorage.getItem("CasOdklopa") !== null)
          this.casOdklopa = localStorage.getItem("CasOdklopa");
        if (localStorage.getItem("Nezakljucen") === 'true')
          this.nezakljucen = true;
        if (localStorage.getItem("Pristanek") !== null)
          this.pristanek = localStorage.getItem("Pristanek");
        if (localStorage.getItem("PristanekM") !== null)
          this.pristanekM = localStorage.getItem("PristanekM");
        if (localStorage.getItem("Opomba") !== null)
          this.opomba = localStorage.getItem("Opomba");
        if (localStorage.getItem("pilotNameM") !== null)
          this.pilotNameM = localStorage.getItem("pilotNameM");
        if (localStorage.getItem("regVleka") !== null)
          this.regVleka = localStorage.getItem("regVleka");
      } else {
        localStorage.removeItem("PilotName");
        localStorage.removeItem("InstructorName");
        localStorage.removeItem("RegLetala");
        localStorage.removeItem("Namen");
        localStorage.removeItem("Naloga");
        localStorage.removeItem("KrajVzleta");
        localStorage.removeItem("KrajPristanka");
        localStorage.removeItem("Poletanje");
        localStorage.removeItem("CasOdklopa");
        localStorage.removeItem("Nezakljucen");
        localStorage.removeItem("Pristanek");
        localStorage.removeItem("pilotNameM");
        localStorage.removeItem("regVleka");
        localStorage.removeItem("PristanekM");
        localStorage.removeItem("Opomba");
      }
    },
    CreatingLocal() {
      localStorage.setItem("Datum", new Date().toISOString().split('T')[0]);
      localStorage.setItem("PilotName", this.pilotName);
      localStorage.setItem("InstructorName", this.instructorName);
      localStorage.setItem("RegLetala", this.regLetala);
      localStorage.setItem("Namen", this.IzbranNamen);
      localStorage.setItem("Naloga", this.IzbranaNaloga);
      if (localStorage.getItem("KrajVzleta") === '' || localStorage.getItem("KrajVzleta") === null) {
        localStorage.setItem("KrajVzleta", 'LJAJ');
      } else {
        localStorage.setItem("KrajVzleta", this.krajVzleta);
      }
      if (localStorage.getItem("KrajPristanka") === '' || localStorage.getItem("KrajPristanka") === null) {
        localStorage.setItem("KrajPristanka", 'LJAJ');
      } else {
        localStorage.setItem("KrajPristanka", this.krajPristanka);
      }
      localStorage.setItem("Poletanje", this.poletanje);
      localStorage.setItem("CasOdklopa", this.casOdklopa);
      localStorage.setItem("Nezakljucen", this.nezakljucen);
      localStorage.setItem("Pristanek", this.pristanek);
      localStorage.setItem("pilotNameM", this.pilotNameM);
      localStorage.setItem("regVleka", this.regVleka);
      localStorage.setItem("PristanekM", this.pristanekM);
      localStorage.setItem("Opomba", this.opomba);
    },
    GetLetalisca() {
      let app = this;
      axios
          .get("./api/sifranti/letalisca/beri/")
          .then(function (response) {
            app.Letalisca = response.data;
          })
          .catch((napaka) => {
            if (napaka.response.status === 401) {
              this.$router.push('/Logout');
            }
            if (napaka.response.data.napaka !== undefined) {
              // this.text = 'Napaka pri branju podatkov. '+napaka.response.data.napaka;
              this.text = this.$t('obvestila.vnosNeuspesen');
            } else {
              this.text = this.$t('obvestila.vnosNeuspesen');
            }
            this.types = 'Napaka';
            this.ShowNoti = true;
          })
    },
    Add() {
      if (this.datum !== '' && this.pilotName !== '' && this.regLetala !== '' && this.IzbranNamen !== '' && this.IzbranaNaloga !== '' && this.krajVzleta !== '' && this.krajPristanka !== '' && this.casOdklopa !== '') {
        this.vnasam = true;
        let app = this;
        let dodaj = new URLSearchParams();
        const datumDanes = new Date().toISOString().split('T')[0];
        if (app.datum > datumDanes) {
          // alert("Zapis ima izbran datum v prihodnosti, POPRAVI izbran datum!");
          this.text = this.$t('obvestila.zapisPrihodnost');
          this.types = "Napaka";
          this.ShowNoti = true;
          return;
        } else {
          if (app.datum === datumDanes) {
            //preverjanje časa, da ni v prihodnosti
            let cas = new Date();
            cas.setHours(cas.getHours() + 2); //dodamo +2 uri zaradi časovnega pasa
            cas.setMinutes(cas.getMinutes() + 15); //dovolimo 15 minut v prihodnost
            cas = cas.toISOString().split('T')[1].split('.')[0];
            let casP = new Date();
            casP.setHours(casP.getHours() + 2); //dodamo +2 uri zaradi časovnega pasa
            casP = casP.toISOString().split('T')[1].split('.')[0];
            if (this.poletanje > casP || this.casOdklopa > cas || this.pristanek > cas) {
              // alert("Zapis ima pri enem ali več zapisih uro v prihodnosti, preglej čase!");
              this.text = this.$t('obvestila.zapisCasPrihodnost');
              this.types = "Napaka";
              this.ShowNoti = true;
              return;
            }
          }
          dodaj.append('datum', app.datum);
          dodaj.append('pilot', app.pilotName);
          dodaj.append('instruktor', app.instructorName);
          dodaj.append('reg_letala', app.regLetala);
          dodaj.append('namen', app.IzbranNamen);
          dodaj.append('naloga', app.IzbranaNaloga);
          dodaj.append('kraj_vzleta', app.krajVzleta);
          dodaj.append('kraj_pristanka', app.krajPristanka);
          dodaj.append('poletanje', app.poletanje);
          dodaj.append('cas_odklopa', app.casOdklopa);
          dodaj.append('cas_vleke', app.casVleke);
          dodaj.append('pristanek', app.pristanek);
          // dodaj.append('kilometri', app.kilometri);
          dodaj.append('reg_vleke', app.regVleka);
          dodaj.append('opomba', app.opomba);
          axios
              .post("./api/log/jadralno/vnos/", dodaj, {withCredentials: true})
              .then(function (response) {
                app.vnasam = false;
                // alert("Zapis uspešno dodan!");
                app.text = app.$t('obvestila.zapisDodan');
                app.types = "Uspešno";
                app.ShowNoti = true;
                // localStorage.clear("PilotName");
                // localStorage.clear("InstructorName");
                // localStorage.clear("RegLetala");
                // localStorage.clear("Namen");
                // localStorage.clear("Naloga");
                // localStorage.clear("Nezakljucen");
                // localStorage.clear("regVleka");
                localStorage.removeItem("KrajVzleta");
                localStorage.removeItem("KrajPristanka");
                localStorage.removeItem("Poletanje");
                localStorage.removeItem("CasOdklopa");
                localStorage.removeItem("Pristanek");
                // localStorage.removeItem("pilotNameM");
                localStorage.removeItem("PristanekM");
                localStorage.removeItem("Opomba");
                app.datum = new Date().toISOString().split('T')[0];
                // app.pilotName = '';
                // app.instructorName = '';
                // app.regLetala = '';
                // app.IzbranNamen = '';
                // app.IzbranaNaloga = '';
                app.krajVzleta = 'LJAJ';
                app.krajPristanka = 'LJAJ';
                app.poletanje = '';
                app.casOdklopa = '';
                app.casVleke = '';
                app.pristanek = '';
                // app.regVleka = '';
                app.opomba = '';
                app.GetPodatkiObracuna();
                // app.WriteLocal();
                var requiredPolja = ['datum', 'pilotName', 'regLetala', 'pilotNameM', 'IzbranaNaloga', 'IzbranNamen', 'regVleka', 'krajVzleta', 'krajPristanka', 'poletanje', 'pristanekM', 'casOdklopa'];
                app.ResetRequired(requiredPolja);
              })
              .catch((napaka) => {
                app.vnasam = false;
                if (napaka.response.status === 401) {
                  this.$router.push('/Logout');
                }
                if (napaka.response.data.napaka !== undefined) {
                  // this.text = 'Napaka pri vnosu podatkov. '+napaka.response.data.napaka;
                  this.text = this.$t('obvestila.zapisNapaka');
                  this.ErrorReport('napaka-jadralna-vnos', '/api/log/jadralno/vnos/', 'Add()', 'Jadralna-vnos-dodajanje-leta', this.text);
                } else {
                  this.text = this.$t('obvestila.zapisNapaka');
                  this.ErrorReport('napaka-jadralna-vnos', '/api/log/jadralno/vnos/', 'Add()', 'Jadralna-vnos-dodajanje-leta', this.text);
                }
                this.types = 'Napaka';
                this.ShowNoti = true;
              })
        }
      } else {
        var requiredPolja = ['datum', 'pilotName', 'regLetala', 'pilotNameM', 'IzbranaNaloga', 'IzbranNamen', 'regVleka', 'krajVzleta', 'krajPristanka', 'poletanje', 'pristanekM', 'casOdklopa'];
        this.CheckInputs(requiredPolja);
        // alert("Napaka pri vnosu, eden od podatkov ni vnešen!");
        this.text = this.$t('obvestila.napakaInputa');
        this.types = "Napaka";
        this.ShowNoti = true;
        this.ErrorReport('napaka-jadralna-vnos', '/api/log/jadralno/vnos/', 'Add()', 'Jadralna-vnos-dodajanje-leta', 'Uporabnik ni izpolnil vseh polj');
      }

    },
    AddMotorno() {
      if (this.datum !== '' && this.pilotNameM !== '' && this.regVleka !== '' && this.IzbranNamen !== '' && this.krajVzleta !== '' && this.krajPristanka !== '' && this.poletanje !== '' && this.pristanekM !== '') {
        this.vnasam = true;
        let app = this;
        let dodaj = new URLSearchParams();
        const datumDanes = new Date().toISOString().split('T')[0];
        if (app.datum > datumDanes) {
          // alert("Zapis ima izbran datum v prihodnosti, POPRAVI izbran datum!");
          app.text = app.$t('obvestila.zapisPrihodnost');
          app.types = "Napaka";
          app.ShowNoti = true;
          return;
        } else {
          if (app.datum === datumDanes) {
            //preverjanje časa, da ni v prihodnosti
            let cas = new Date();
            cas.setHours(cas.getHours() + 2); //dodamo +2 uri zaradi časovnega pasa
            cas.setMinutes(cas.getMinutes() + 15); //dovolimo 15 minut v prihodnost
            cas = cas.toISOString().split('T')[1].split('.')[0];
            let casP = new Date();
            casP.setHours(casP.getHours() + 2); //dodamo +2 uri zaradi časovnega pasa
            casP = casP.toISOString().split('T')[1].split('.')[0];
            if (this.poletanje > casP || this.pristanek > cas) {
              this.vnasam = false;
              // alert("Zapis ima pri enem ali več zapisih uro v prihodnosti, preglej čase!");
              this.text = this.$t('obvestila.zapisCasPrihodnost');
              this.types = "Napaka";
              this.ShowNoti = true;
              return;
            }
          }
          if (this.pristanekM <= this.poletanje || this.casOdklopa <= this.poletanje || this.casOdklopa >= this.pristanekM) {
            this.vnasam = false;
            this.text = this.$t('obvestila.zapisCasNapaka');
            this.types = "Napaka";
            this.ShowNoti = true;
            return;
          }
          if (this.pristanek !== '') {
            if (this.pristanek <= this.poletanje || this.casOdklopa >= this.pristanek) {
              this.vnasam = false;
              this.text = this.$t('obvestila.zapisCasNapaka');
              this.types = "Napaka";
              this.ShowNoti = true;
              return;
            }
          }
          dodaj.append('datum', app.datum);
          dodaj.append('pilot', app.pilotNameM);
          dodaj.append('instruktor', '');
          dodaj.append('reg_letala', app.regVleka);
          dodaj.append('namen', app.IzbranNamenM);
          dodaj.append('naloga', app.IzbranaNalogaM);
          dodaj.append('kraj_vzleta', app.krajVzleta);
          dodaj.append('kraj_pristanka', app.krajPristanka);
          dodaj.append('poletanje', app.poletanje);
          dodaj.append('cas_vziga', '');
          dodaj.append('pristanek', app.pristanekM);
          dodaj.append('cas_ugasanja', '');
          dodaj.append('opomba', app.opomba);
          dodaj.append('st_pristankov', 1);
          axios
              .post("./api/log/motorno/vnos/", dodaj, {withCredentials: true})
              .then(function (response) {
                app.vnasam = false;
                setTimeout(() => {
                  app.GetCasVleke();
                }, 100);
                // app.pilotNameM = '';
                // app.IzbranNamenM = '';
                app.pristanekM = '';
              })
              .catch((napaka) => {
                if (napaka.response.status === 401) {
                  this.$router.push('/Logout');
                }
                if (napaka.response.data.napaka !== undefined) {
                  // this.text = 'Napaka pri vnosu podatkov (motorno vleka). '+napaka.response.data.napaka;
                  this.text = this.$t('obvestila.zapisNapakaMotorno');
                  this.ErrorReport('napaka-jadralna-vnos', '/api/log/motorno/vnos/', 'AddMotorno()', 'Jadralna-vnos-dodajanje-leta', this.text);
                } else {
                  this.text = this.$t('obvestila.zapisNapakaMotorno');
                  this.ErrorReport('napaka-jadralna-vnos', '/api/log/motorno/vnos/', 'AddMotorno()', 'Jadralna-vnos-dodajanje-leta', this.text);
                }
                this.types = 'Napaka';
                this.ShowNoti = true;
              })
        }
      } else {
        var requiredPolja = ['datum', 'pilotName', 'regLetala', 'pilotNameM', 'IzbranaNaloga', 'IzbranNamen', 'regVleka', 'krajVzleta', 'krajPristanka', 'poletanje', 'pristanekM', 'casOdklopa'];
        this.CheckInputs(requiredPolja);
        // alert('Napaka pri vnosu, preglej če imaš izpolnjena vsa polja!');
        this.text = this.$t('obvestila.napakaInputa');
        this.types = "Napaka";
        this.ShowNoti = true;
        this.ErrorReport('napaka-jadralna-vnos', '/api/log/motorno/vnos/', 'AddMotorno()', 'Jadralna-vnos-dodajanje-leta', 'Uporabnik ni izpolnil vseh polj');
      }

    },
    CheckInputs(inputsArray) {
      //funkcija, ki preveri "obvezne" inpute in jih obarva rdeče, če niso nastavljeni
      for (var i = 0; i < inputsArray.length; i++) {
        if (this[inputsArray[i]] === '') {
          // console.log(inputsArray[i]);
          $('#' + inputsArray[i]).addClass('required-field');
        } else {
          $('#' + inputsArray[i]).removeClass('required-field');
        }
      }
    },
    ResetRequired(inputsArray) {
      for (var i = 0; i < inputsArray.length; i++) {
        $('#' + inputsArray[i]).removeClass('required-field');
      }
    },
    GetLetala() {
      let app = this;
      axios
          .get("./api/sifranti/letala/izpis/")
          .then(function (response) {
            for (let i = 0; i < response.data.letala.length; i++) {
              if (response.data.letala[i].vrsta_letala === 'Jadralno') {
                app.Letala.push(response.data.letala[i]);
              } else if (response.data.letala[i].vrsta_letala === 'Motorno') {
                app.LetalaMotorna.push(response.data.letala[i]);
              }
            }
            app.LetalaMotorna = app.LetalaMotorna.filter(letalo => letalo.vlecno === true); //dodano filtriranje za prikaz samo letal, ki so označena za vleko
            // alert("Zapis uspešno dodan!");
            // app.LetalaMotorna = response.data;
          })
          .catch((napaka) => {
            if (napaka.response.status === 401) {
              this.$router.push('/Logout');
            }
            if (napaka.response.data.napaka !== undefined) {
              this.text = this.$t('obvestila.napakaBranja');
            } else {
              this.text = this.$t('obvestila.napakaBranja');
            }
            this.types = 'Napaka';
            this.ShowNoti = true;
          })
    },
    GetPiloti() {
      let app = this;
      axios
          .get("./api/sifranti/piloti/izpis/")
          .then(function (response) {
            // alert("Zapis uspešno dodan!");
            if (app.user.lvl < 4) {
              app.Piloti.piloti = response.data.piloti.filter(pilot => pilot.datum_izbrisa == null);
              app.PilotiV = response.data;
            } else {
              app.Piloti.piloti = response.data.piloti.filter(pilot => pilot.email === app.user.email);
              app.PilotiV = response.data;
            }
            // app.Instruktor = response.data.piloti.map(pilot => pilot.instruktor);
            app.Instruktor = response.data.piloti.filter(pilot => pilot.instruktor_jadralno === true && pilot.datum_izbrisa == null);
          })
          .catch((napaka) => {
            if (napaka.response.status === 401) {
              this.$router.push('/Logout');
            }
            if (napaka.response.data.napaka !== undefined) {
              this.text = this.$t('obvestila.napakaBranja');
            } else {
              this.text = this.$t('obvestila.napakaBranja');
            }
            this.types = 'Napaka';
            this.ShowNoti = true;
          })
    },
    GetPodatkiObracuna() {
      let app = this;
      let podatki = new URLSearchParams();
      podatki.append("datumZ", this.datumO);
      podatki.append("datumK", this.datumD);
      var Ddatum = new Date().toISOString().split('T')[0];
      if (this.datumO !== Ddatum && this.user.lvl === 3) { //če je uporabnik kronometrist in bi rad gledal lete za nazaj prikažemo samo njegove lete
        podatki.append("posamezno", true);
      }
      if (this.user.lvl > 3) { //če je uporabnik "pilot", prikažemo samo današnje lete, drugače vse
        podatki.append("posamezno", true);
      }
      axios
          .post("./api/log/jadralno/izpis/", podatki)
          .then(function (response) {
            app.PodatkiObracun = response.data.podatki;
            app.GetPodatkiNezakljucenih();
          })
          .catch((napaka) => {
            if (napaka.response.status === 401) {
              this.$router.push('/Logout');
            }
            if (napaka.response.data.napaka !== undefined) {
              this.text = this.$t('obvestila.napakaBranja');
            } else {
              this.text = this.$t('obvestila.napakaBranja');
            }
            this.types = 'Napaka';
            this.ShowNoti = true;
          })
    },
    GetPodatkiNezakljucenih() {
      let podatki = new URLSearchParams();
      podatki.append("datumZ", this.datum);
      podatki.append("datumK", this.datum);
      axios
          .post("./api/log/jadralno/izpis/nezakljuceni/", podatki)
          .then((response) => {
            this.PodatkiNezakljuceni = response.data.podatki;
          })
          .catch((napaka) => {
            if (napaka.response.status === 401) {
              this.$router.push('/Logout');
            }
            if (napaka.response.data.napaka !== undefined) {
              this.text = this.$t('obvestila.napakaBranjaNezakljuceni');
            } else {
              this.text = this.$t('obvestila.napakaBranjaNezakljuceni');
            }
            this.types = 'Napaka';
            this.ShowNoti = true;
          })
    },
    SetDatumO(datum) {
      this.datumO = datum;
    },
    SetDatumK(datum) {
      this.datumD = datum;
    },
    GetCasVleke() {
      var podatki = new URLSearchParams();
      podatki.append('poletanje', this.poletanje);
      podatki.append('datum', this.datum);
      podatki.append('reg_vleke', this.regVleka);
      axios.post('./api/log/motorno/izpis/', podatki, {withCredentials: true}).then((response) => {
        this.casVleke = response.data.cas_vleke;
        // if(response.data.cas_vleke == null) {
        //     this.casVleke = "00:00";
        //     alert('Pozor! Izbrano letalo za vleko nima zapisanega časa letenja! Preverite, da ste izbrali pravilno registracijo letala, drugače bo zapisan čas vleke 00:00!');
        // }
        setTimeout(() => {
          this.Add();
        }, 200);
      }).catch((napaka) => {
        if (napaka.response.status === 401) {
          this.$router.push('/Logout');
        }
        if (napaka.response.data.napaka !== undefined) {
          this.text = this.$t('obvestila.napakaBranjaCasVleke');
        } else {
          this.text = this.$t('obvestila.napakaBranjaCasVleke');
        }
        this.types = 'Napaka';
        this.ShowNoti = true;
      });
    },
    selectPilot(id) {
      let pilot = this.Piloti.piloti.find(p => p.id === id);
      if (pilot) {
        // this.pilotName = pilot.ime + ' ' + pilot.priimek;
        this.pilotName = pilot.sifra;
        this.dPilot = false;
        this.CreatingLocal();
      }
    },
    selectPilotM(id) {
      let pilot = this.PilotiV.piloti.find(p => p.id === id);
      if (pilot) {
        // this.pilotName = pilot.ime + ' ' + pilot.priimek;
        this.pilotNameM = pilot.sifra;
        this.dPilotM = false;
        this.CreatingLocal();
      }
    },
    selectInstructor(id) {
      let instruktor = this.Piloti.piloti.find(ins => ins.id === id);
      if (instruktor) {
        this.instructorName = instruktor.ime + ' ' + instruktor.priimek;
        this.dInstruktor = false;
        this.CreatingLocal();
      }
    },
    selectLetalo(id) {
      // let letalo = this.Letala.letala.find(l => l.id === id);
      let letalo = this.Letala.find(l => l.id === id);
      if (letalo) {
        if (!letalo.plovnost) {
          this.text = `Izbrali ste letalo katerega je upravitelj označil kot \'neplovno\'. Opomba: ${letalo.plovnost_opomba !== null ? letalo.plovnost_opomba : '/'}`;
          this.types = 'Napaka';
          this.ShowNoti = true;
        }
        this.regLetala = letalo.registracija;
        this.dLetalo = false; // Zapri dropdown po izbiri
        this.CreatingLocal();
      }
    },
    selectNamen(id) {
      let namen = this.namen.find(n => n.id === id);
      if (namen) {
        this.dNamen = false;
        this.IzbranNamen = namen.namen;
        this.CreatingLocal();
      }
    },
    selectNamenM(id) {
      let namen = this.namen.find(n => n.id === id);
      if (namen) {
        this.dNamenM = false;
        this.IzbranNamenM = namen.namen;
        this.CreatingLocal();
      }
    },
    selectNaloga(id) {
      let naloga = this.naloga.find(na => na.id === id);
      if (naloga) {
        this.dNaloga = false;
        this.IzbranaNaloga = naloga.naloga;
        this.CreatingLocal();
      }
    },
    selectLetaloVleke(id) {
      let motorno = this.LetalaMotorna.find(mo => mo.id === id);
      if (motorno) {
        this.regVleka = motorno.registracija;
        this.dLetaloVleka = false; // Zapri dropdown po izbiri
        this.CreatingLocal();
      }
    },
    selectPristanek(id) {
      let pristanek = this.Letalisca.letalisca.find(pr => pr.id === id);
      if (pristanek) {
        this.dPristanek = false;
        this.krajPristanka = pristanek.icao;
        this.CreatingLocal();
      }
    },
    selectVzlet(id) {
      let vzlet = this.Letalisca.letalisca.find(vl => vl.id === id);
      if (vzlet) {
        this.dVzlet = false;
        this.krajVzleta = vzlet.icao;
        this.CreatingLocal();
      }
    },
    EmptyLetaloVleka() {
      this.regVleka = '';
      this.CreatingLocal();
    },
    OpenPilot() {
      this.dPilot = !this.dPilot;
    },
    OpenPilotM() {
      this.dPilotM = !this.dPilotM;
    },
    OpenLetalo() {
      this.dLetalo = !this.dLetalo;
    },
    OpenInstructor() {
      this.dInstruktor = !this.dInstruktor;
    },
    OpenNamen() {
      this.dNamen = !this.dNamen;
    },
    OpenNamenM() {
      this.dNamenM = !this.dNamen;
    },
    OpenNaloga() {
      this.dNaloga = !this.dNaloga;
    },
    OpenVzlet() {
      this.dVzlet = !this.dVzlet;
    },
    OpenPristanek() {
      this.dPristanek = !this.dPristanek;
    },
    OpenMotorna() {
      this.dLetaloVleka = !this.dLetaloVleka;
    },
    async loadTranslations(lang, path) {
      const response = await fetch(path);
      const json = await response.json();
      i18n.global.mergeLocaleMessage(lang, json);
      // this.$i18n.mergeLocaleMessage(lang, json);
    },
    loadTranslationsDirekt(lang, messages) {
      i18n.global.mergeLocaleMessage(lang, messages)
    },
    changeLang(lang) {
      i18n.global.locale.value = lang
    },
    ErrorReport(imeEventa, endpoint = null, metoda = null, imeNapake = null, opisNapake = null) {
      window.umami.track(imeEventa, {
        endpoint: endpoint,
        metoda: metoda,
        akcija: imeNapake,
        opis: opisNapake
      });
    },
    DodajLetalisce() {
      $(this.$refs.modalDodajanjaLetalisca).modal('show');
      setTimeout(() => {
        $('#novIcao').focus();
      }, 200);
    },
    ZapriModal() {
      this.dodajanjeLetalisca = false;
      $(this.$refs.modalDodajanjaLetalisca).modal('hide');
    },
    PreveriIcao() {
      this.dodajanjeLetalisca = true;
      if (this.Letalisca.letalisca.some(letalisce => letalisce.icao === this.novIcao)) {
        this.text = 'Letališče že obstaja v naši bazi podatkov';
        this.ShowNoti = true;
        this.types = 'Napaka';
        this.dodajanjeLetalisca = false;
      } else {
        var podatki = new URLSearchParams();
        podatki.append('icao', this.novIcao);
        axios.post('./api/letalisca/', podatki).then((response) => {
          if (response.data.podatki.statusCode === 404) {
            this.text = this.$t('obvestila.letalisceNiNajdeno');
            this.ShowNoti = true;
            this.types = "Napaka";
            this.dodajanjeLetalisca = false;
            return;
          }
          if (response.data.podatki) {
            var ime_letalisca = response.data.podatki.name;
            this.imeDodanegaLetalisca = ime_letalisca;
            var vnos = new URLSearchParams();
            vnos.append('icao', this.novIcao);
            vnos.append('naziv', ime_letalisca);
            axios.post('./api/urednik/letalisca/dodaj/', vnos).then((response) => {
              this.GetLetalisca();
              this.text = this.$t('obvestila.vnosLetaliscaUspesen');
              this.ShowNoti = true;
              this.types = "Uspešno";
              this.dodajanjeLetalisca = false;
              this.letalisceDodano = true;
              setTimeout(() => {
                this.letalisceDodano = false;
                this.novIcao = '';
                $('#novIcao').focus();
              }, 3500);
            }).catch((napaka) => {
              if (napaka.response.data.napaka !== undefined) {
                this.text = this.$t('obvestila.napakaDodajanjaLetalisca');
              } else {
                this.text = this.$t('obvestila.napakaDodajanjaLetalisca');
              }
              this.ShowNoti = true;
              this.types = "Napaka";
              this.dodajanjeLetalisca = false;
            });
          }
        }).catch((napaka) => {
          this.text = this.$t('obvestila.napakaDodajanjaLetalisca');
          this.ShowNoti = true;
          this.types = "Napaka";
          this.dodajanjeLetalisca = false;
        });
      }
    }
  }
}
</script>
<template>
  <!--         <div class="upper-cloud border-bottom-0 rounded-bottom-4 p-2">
            <button class="p-2 btn-back" @click.prevent="$emit('back')"><i class="fas fa-arrow-left fa-2x"></i></button>
            <h4 class="d-flex justify-content-center text-white">Jadralni leti</h4>
        </div>
        <div class='text-center'>
            <span class='btn btn-sm text-white' :class="{'border-bottom': this.prikaz == 'vnos'}" @click.prevent="this.prikaz = 'vnos'">Vnos</span> | <span class='btn btn-sm text-white' :class="{'border-bottom': this.prikaz == 'zapisi'}" @click.prevent="this.prikaz = 'zapisi'">Zapisi</span>
        </div> -->
  <div class="pregled-povrsin-container">
    <!-- Modern Header -->
    <div class="modern-header">
      <div class="header-content">
        <!-- Back Button -->
        <div class="header-section header-left">
          <button class="back-btn" @click.prevent="$router.push('/')">
            <i class="fas fa-arrow-left"></i>
            <span>{{ $t('main.nazaj') }}</span>
          </button>
        </div>

        <!-- Title -->
        <div class="header-section header-center">
          <h1 class="page-title">{{ $t('main.title') }}</h1>
          <!-- <p class="page-subtitle">Obrazec št. 1 - Poročilo o pregledu površin za gibanje zrakoplovov</p> -->
        </div>

        <!-- Navigation Tabs -->
        <div class="header-section header-right">
          <div class="nav-tabs">
            <button class="nav-tab" :class="{'active': prikaz === 'vnos'}" @click="prikaz = 'vnos'"
                    data-umami-event="Jadralna-vnos">
              <i class="fas fa-edit"></i>
              <span>{{ $t('nav.vnos') }}</span>
            </button>
            <button class="nav-tab" :class="{'active bg-rdeca': prikaz === 'zapisi'}" @click="prikaz = 'zapisi'"
                    data-umami-event="Jadralna-zapisi">
              <i class="fas fa-list"></i>
              <span>{{ $t('nav.zapisi') }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <zapisi v-show="this.prikaz === 'zapisi'" :PodatkiObracun="this.PodatkiObracun"
          :PodatkiNezakljuceni="this.PodatkiNezakljuceni" @datumo="SetDatumO" @datumk="SetDatumK"
          @osvezi="GetPodatkiObracuna()" :user="this.user"/>
  <div class="container p-2" v-show="this.prikaz === 'vnos' && prevodi">
    <Transition name="fade">
      <Notification v-if="ShowNoti" :message="this.text" :type="this.types" @closeNotification="ShowNoti = false"/>
    </Transition>
    <div class="col-12">
      <div class="container">
        <div class="label-date p-2 col-6" for="datum">Datum :</div>
        <input class="input border-0 rounded-4 p-2 fs-5" type="date" id="datum" v-model="datum" required/>
      </div>
    </div>
    <div class="hr-with-text p-2">{{ $t('main.subtitle1') }}</div>
    <div class="col-12">
      <!-- <div class="container">
          <label :class="{ hidden: pilotName.length > 0 }" class="label" for="pilotName">Pilot / Učenec</label>
          <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="pilotName" v-model="pilotName" required />
      </div> -->
      <div class="container">
        <label class="label-dropdown" for="pilotName">{{ $t('labels.pilotJ') }}
          <button v-if="pilotName !== ''" class="btn btn-sm btn-outline-warning"
                  @click.prevent="pilotName = '', CreatingLocal()">{{ $t('buttons.brisiIzbiro') }}
          </button>
        </label>
        <div class="drop-down-icon text-black" @click.prevent="OpenPilot()">
          <i v-show="!dPilot" class="fas fa-chevron-right"></i>
          <i v-show="dPilot" class="fas fa-chevron-down"></i>
        </div>
        <button class="input border-0 rounded-4 p-2 fs-5" type="text" id="pilotName" @click.prevent="OpenPilot">
          {{ pilotName }}
        </button>
        <transition name="fade">
          <drop-down @pilot="selectPilot" :data="Piloti" type="piloti" class="drop-down-btn" v-if="dPilot"/>
        </transition>
      </div>
    </div>
    <div class="col-12">
      <!-- <div class="container">
          <label :class="{ hidden: instructorName.length > 0 }" class="label" for="instructorName">Učitelj</label>
          <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="instructorName" v-model="instructorName" required />
      </div> -->
      <div class="container">
        <label class="label-dropdown" for="instructorName">{{ $t('labels.instruktor') }}
          <button v-if="instructorName !== ''" class="btn btn-sm btn-outline-warning"
                  @click.prevent="instructorName = '', CreatingLocal()">{{ $t('buttons.brisiIzbiro') }}
          </button>
        </label>
        <div class="drop-down-icon text-black" @click.prevent="OpenInstructor()">
          <i v-show="!dInstruktor" class="fas fa-chevron-right"></i>
          <i v-show="dInstruktor" class="fas fa-chevron-down"></i>
        </div>
        <button class="input border-0 rounded-4 p-2 fs-5" id="instructorName" @click.prevent="OpenInstructor">
          {{ instructorName }}
        </button>
        <transition name="fade">
          <drop-down @instruktor="selectInstructor" :data="Instruktor" type="instruktor" class="drop-down-btn"
                     v-if="dInstruktor"/>
        </transition>
      </div>
    </div>
    <div class="col-12">
      <!-- <div class="container">
          <label :class="{ hidden: regLetala.length > 0 }" class="label" for="regLetala">Letalo</label>
          <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="regLetala" v-model="regLetala" required />
      </div> -->
      <div class="container">
        <label class="label-dropdown" for="regLetala">{{ $t('labels.registracijaJ') }}
          <button v-if="regLetala !== ''" class="btn btn-sm btn-outline-warning"
                  @click.prevent="regLetala = '', CreatingLocal()">{{ $t('buttons.brisiIzbiro') }}
          </button>
        </label>
        <div class="drop-down-icon text-black" @click.prevent="OpenLetalo()">
          <i v-show="!dLetalo" class="fas fa-chevron-right"></i>
          <i v-show="dLetalo" class="fas fa-chevron-down"></i>
        </div>
        <button class="input border-0 rounded-4 p-2 fs-5" id="regLetala" @click.prevent="OpenLetalo">{{ regLetala }}
        </button>
        <transition name="fade">
          <drop-down @letalo="selectLetalo" :data="Letala" type="letalo" class="drop-down-btn" v-if="dLetalo"/>
        </transition>
      </div>
    </div>
    <div class="col-12">
      <!-- <div class="container">
          <label :class="{ hidden: namen.length > 0 }" class="label" for="namen">Namen</label>
          <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="namen" v-model="namen" required />
      </div> -->
      <div class="container">
        <label class="label-dropdown" for="namen">{{ $t('labels.namenJ') }}
          <button v-if="IzbranNamen !== ''" class="btn btn-sm btn-outline-warning"
                  @click.prevent="IzbranNamen = '', CreatingLocal()">{{ $t('buttons.brisiIzbiro') }}
          </button>
        </label>
        <div class="drop-down-icon text-black" @click.prevent="OpenNamen()">
          <i v-show="!dNamen" class="fas fa-chevron-right"></i>
          <i v-show="dNamen" class="fas fa-chevron-down"></i>
        </div>
        <button id="IzbranNamen" class="input border-0 rounded-4 p-2 fs-5" type="text" @click.prevent="OpenNamen">
          {{ IzbranNamen }}
        </button>
        <transition name="fade">
          <drop-down @namen="selectNamen" :data="namen" type="namen" class="drop-down-btn" v-if="dNamen"/>
        </transition>
      </div>
    </div>
    <div class="col-12">
      <!-- <div class="container">
          <label :class="{ hidden: naloga.length > 0 }" class="label" for="naloga">Naloga</label>
          <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="naloga" v-model="naloga" required />
      </div> -->
      <div class="container">
        <label class="label-dropdown" for="naloga">{{ $t('labels.nalogaJ') }}
          <button v-if="IzbranaNaloga !== ''" class="btn btn-sm btn-outline-warning"
                  @click.prevent="IzbranaNaloga = '', CreatingLocal()">{{ $t('buttons.brisiIzbiro') }}
          </button>
        </label>
        <div class="drop-down-icon text-black" @click.prevent="OpenNaloga()">
          <i v-show="!dNaloga" class="fas fa-chevron-right"></i>
          <i v-show="dNaloga" class="fas fa-chevron-down"></i>
        </div>
        <button class="input border-0 rounded-4 p-2 fs-5" type="text" id="IzbranaNaloga" @click.prevent="OpenNaloga">
          {{ IzbranaNaloga }}
        </button>
        <transition name="fade">
          <drop-down @naloga="selectNaloga" :data="naloga" type="naloga" class="drop-down-btn" v-if="dNaloga"/>
        </transition>
      </div>
    </div>
    <div class="hr-with-text p-2">{{ $t('main.subtitle2') }}</div>
    <!-- PILOT MOTORNO -->
    <div class="col-12">
      <div class="container">
        <label class="label-dropdown" for="pilotName">{{ $t('labels.pilotM') }}
          <button v-if="pilotNameM !== ''" class="btn btn-sm btn-outline-warning"
                  @click.prevent="pilotNameM = '', CreatingLocal()">{{ $t('buttons.brisiIzbiro') }}
          </button>
        </label>
        <div class="drop-down-icon text-black" @click.prevent="OpenPilotM()">
          <i v-show="!dPilotM" class="fas fa-chevron-right"></i>
          <i v-show="dPilotM" class="fas fa-chevron-down"></i>
        </div>
        <button class="input border-0 rounded-4 p-2 fs-5" id="pilotNameM" @click.prevent="OpenPilotM">{{ pilotNameM }}
        </button>
        <transition name="fade">
          <drop-down @pilot="selectPilotM" :data="FilterVlecnihPilotov" type="piloti_vlecni" class="drop-down-btn"
                     v-if="dPilotM"/>
        </transition>
      </div>
    </div>
    <!-- REG. VLEČNEGA LETALA -->
    <div class="col-12">
      <div class="container">
        <label class="label-dropdown" for="regLetala">{{ $t('labels.registracijaM') }}
          <button v-if="regVleka !== ''" class="btn btn-sm btn-outline-warning"
                  @click.prevent="regVleka = '', CreatingLocal()">{{ $t('buttons.brisiIzbiro') }}
          </button>
        </label>
        <div class="drop-down-icon text-black" @click.prevent="OpenMotorna()">
          <i v-show="!dLetaloVleka" class="fas fa-chevron-right"></i>
          <i v-show="dLetaloVleka" class="fas fa-chevron-down"></i>
        </div>
        <button class="input border-0 rounded-4 p-2 fs-5" id="regVleka" @click.prevent="OpenMotorna">{{ regVleka }}
        </button>
        <transition name="fade">
          <drop-down @motorno="selectLetaloVleke" :data="LetalaMotorna" type="motorno" class="drop-down-btn"
                     v-if="dLetaloVleka"/>
        </transition>
      </div>
    </div>
    <div class="hr-with-text p-2">{{ $t('main.subtitle3') }}</div>
    <div class="col-12">
      <!-- <div class="container">
          <label :class="{ hidden: krajVzleta.length > 0 }" class="label" for="krajVzleta">Kraj vzleta</label>
          <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="krajVzleta" v-model="krajVzleta" required />
      </div> -->
      <div class="container">
        <label class="label-dropdown" for="namen">{{ $t('labels.vzlet') }}
          <button v-if="krajVzleta !== ''" class="btn btn-sm btn-outline-warning"
                  @click.prevent="krajVzleta = '', CreatingLocal()">{{ $t('buttons.brisiIzbiro') }}
          </button>
        </label>
        <div class="drop-down-icon text-black" @click.prevent="OpenVzlet()">
          <i v-show="!dVzlet" class="fas fa-chevron-right"></i>
          <i v-show="dVzlet" class="fas fa-chevron-down"></i>
        </div>
        <button class="input border-0 rounded-4 p-2 fs-5" id="krajVzleta" @click.prevent="OpenVzlet">{{ krajVzleta }}
        </button>
        <transition name="fade">
          <drop-down @vzlet="selectVzlet" :data="Letalisca" type="vzlet" @novoLetalisce="DodajLetalisce"
                     class="drop-down-btn" v-if="dVzlet"/>
        </transition>
      </div>
    </div>
    <div class="col-12">
      <!-- <div class="container">
          <label :class="{ hidden: krajPristanka.length > 0 }" class="label" for="krajPristanka">Pristanek</label>
          <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="krajPristanka" v-model="krajPristanka" required />
      </div> -->
      <div class="container">
        <label class="label-dropdown" for="krajPristanka">{{ $t('labels.pristanek') }}
          <button v-if="krajPristanka !== ''" class="btn btn-sm btn-outline-warning"
                  @click.prevent="krajPristanka = '', CreatingLocal()">{{ $t('buttons.brisiIzbiro') }}
          </button>
        </label>
        <div class="drop-down-icon text-black" @click.prevent="OpenPristanek()">
          <i v-show="!dPristanek" class="fas fa-chevron-right"></i>
          <i v-show="dPristanek" class="fas fa-chevron-down"></i>
        </div>
        <button class="input border-0 rounded-4 p-2 fs-5" id="krajPristanka" @click.prevent="OpenPristanek">
          {{ krajPristanka }}
        </button>
        <transition name="fade">
          <drop-down @pristanek="selectPristanek" :data="Letalisca" type="pristanek" @novoLetalisce="DodajLetalisce"
                     class="drop-down-btn" v-if="dPristanek"/>
        </transition>
      </div>
    </div>
    <div class="col-12">
      <div class="container">
        <label :class="{ hidden: poletanje.length > 0 }" class="label-time p-2"
               for="poletanje">{{ $t('labels.poletanje') }}</label>
        <input @change="CreatingLocal()" class="input border-0 rounded-4 p-2 fs-5" type="time" placeholder="Poletanje"
               id="poletanje" v-model="poletanje" required/>
      </div>
    </div>
    <div class="col-12">
      <div class="container">
        <label :class="{ hidden: casOdklopa.length > 0 }" class="label-time p-2"
               for="casOdklopa">{{ $t('labels.odklop') }}</label>
        <input @change="CreatingLocal()" class="input border-0 rounded-4 p-2 fs-5" type="time" placeholder="Odklop"
               id="casOdklopa" v-model="casOdklopa" required/>
      </div>
    </div>
    <div class="col-12">
      <div class='container'>
        <label class="label-choose" for="vlecno">{{ $t('labels.nezakljucen') }}</label>
        <div class="input border-0 rounded-4 p-2 fs-5">
          <input @change="CreatingLocal()" class="input-radio" type="checkbox" value="true" v-model="nezakljucen"/>
        </div>
      </div>
      <div class="container" v-show="!nezakljucen">
        <label :class="{ hidden: pristanek.length > 0 }" class="label-time p-2"
               for="pristanek">{{ $t('labels.pristanekJ') }}</label>
        <input @change="CreatingLocal()" class="input border-0 rounded-4 p-2 fs-5" type="time" placeholder="Pristanek"
               id="pristanek" v-model="pristanek" required/>
      </div>
    </div>
    <!-- PRISTANEK MOTORNEGA -->
    <div class="col-12">
      <div class="container">
        <label :class="{ hidden: pristanekM.length > 0 }" class="label-time p-2"
               for="pristanek">{{ $t('labels.pristanekM') }}</label>
        <input @change="CreatingLocal()" class="input border-0 rounded-4 p-2 fs-5" type="time" placeholder="Pristanek"
               id="pristanekM" v-model="pristanekM" required/>
      </div>
    </div>
    <!-- <div class="col-12">
        <div class="container">
            <label :class="{ hidden: kilometri.length > 0 }" class="label" for="kilometri">Kilometri</label>
            <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="kilometri" v-model="kilometri" required />
        </div>
    </div> -->
    <!--             <div class="col-12">
                    <div class="container">
                        <label :class="{ hidden: regVleka.length > 0 }" class="label" for="regVleka">Vleka</label>
                        <input class="input border-0 rounded-4 p-2 fs-5" type="text" id="regVleka" v-model="regVleka" required />
                    </div>
                </div> -->
    <div class="col-12">
      <div class="container">
        <label :class="{ hidden: opomba.length > 0 }" class="label" for="opomba">{{ $t('labels.opomba') }}</label>
        <textarea @change="CreatingLocal()" class="input-comment border-0 rounded-4 p-2 fs-5" id="opomba"
                  v-model="opomba" rows="6" autocomplete="off"></textarea>
      </div>
    </div>

    <!-- OPOZORILO -->
    <div class='col-12'>
      <div class='container'>
        <div class="label-date p-2 col-12">*{{ $t('labels.opozorilo') }}</div>
      </div>
    </div>

    <div class="container p-2">
      <button @click.prevent="AddMotorno()"
              class="btn btn-primary rounded-pill btn-add col-12"
              data-umami-event="Jadralna-vnos-dodajanje-leta"
              :disabled="vnasam"
      >{{ $t('buttons.vnesiZapis') }} <i class="fas fa-spinner fa-spin" v-if="vnasam"></i>
      </button>
    </div>
    <!-- DODAJ LETALIŠČE MODAL -->
    <div class="modal modal-kartica" ref="modalDodajanjaLetalisca" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content list-dark border-orange">
          <div class='d-flex justify-content-end'>
            <button class="modern-close-btn mt-2 me-2" @click.prevent="ZapriModal">
              <span aria-hidden="true"><i class="fas fa-2x fa-times"></i></span>
            </button>
          </div>
          <!-- Navigation Tabs -->
          <div class='modal-header justify-content-between'>
            <h5 class="card-title"><i class="fas fa-plane fa-lg"></i> {{ $t('labels.dodajLetalisce') }}</h5>
          </div>
          <div class="modal-body col-12">
            <div class="container">
              <label :class="{ hidden: imeUpper.length > 0 }" class="label-time p-2"
                     for="novIcao">{{ $t('labels.novIcao') }}</label>
              <input class="input border-0 rounded-4 p-2 fs-5" type="text" maxlength="30" id="novIcao"
                     v-model="imeUpper"/>
              <div class='text-center text-success mt-2' v-if="letalisceDodano">
                <span class='text-white'>{{ imeDodanegaLetalisca }}</span><br/>
                <i class="fas fa-check text-success text-center"></i> {{ $t('obvestila.vnosLetaliscaUspesen') }}
              </div>
            </div>
            <div class="container p-2 mt-2">
              <button @click.prevent="PreveriIcao()" class="btn btn-primary rounded-pill btn-add col-12"
                      :disabled="this.dodajanjeLetalisca" data-umami-event="Motorna-dodajanje-leta"><i
                  class="fas fa-plus"></i> {{ $t('buttons.dodajLetalisce') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ODMIK OD CAPTCHE -->
    <div class='col-12 p-5'></div>
  </div>
</template>